export const MainButton = ({
  type,
  onClick,
  disabled,
  children,
  className,
}) => {
  return (
    <button
      type={type}
      className={`btn btn-primary px-2-5 py-1-5 ${className}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};
